<template>
  <d-card class="card-small mb-5">
    <spinner-dot v-if="loading" />
    <div v-else>
      <div class="header-data-table">
        <h5 class="header-data-table__heading">
          Demande d'absences temporaire
        </h5>
      </div>
      <data-table
        :data="dayOffGridData"
        :fields="gridColumnsTitle"
        :selectedFields="daysOffFields"
        :fieldsGrid="gridColumnsFields"
        :tableState="state"
        :count="count"
      >
      </data-table>
    </div>
    <simple-modal ref="reasonModal" :motif="selectedMotif" />
  </d-card>
</template>

<script>
import SpinnerDot from '../layout/Loading/spinner-dot';
import DataTable from '../dataTable/dataTable';
import absceneRequestGrid from '../../data/dataTable/absceneRequestGrid.json';
import TimeUtils from '../../utils/TimeUtils';
import SimpleModal from './SimpleModal';

export default {
  name: 'HistorySimpleAbsence',
  components: { SimpleModal, DataTable, SpinnerDot },
  props: ['reference'],
  data() {
    return {
      daysOffHistory: [],
      count: 0,
      model: {},
      selectedMotif: '',
      // all values available for the table
      gridColumnsFields: absceneRequestGrid.grid,
      gridColumnsTitle: absceneRequestGrid.grid.map(grid => grid.title),
      loading: true,
      daysOffFields: [
        'Date demande',
        'Date et heures',
        "Nb d'heures",
        'Status',
        'Motif',
      ],
      daysOffFieldsGridFill: {
        'Date demande': request => TimeUtils.formatDate(request.creationDate),
        'Date et heures': request =>
          `De ${TimeUtils.formatDateTime(request.dates[0].from)} a ${TimeUtils.formatDateTime(request.dates[0].to)}`,
        "Nb d'heures": request => `${request.model.totalHours} heures`,
        Status: request => request.status || 'En attente...',
        Motif: (request) => {
          if (request.declineReason) {
            return {
              component: 'button-td',
              class: 'btn-danger',
              icon: 'fa fa-eye',
              action: this.showReason,
              id: request.declineReason,
            };
          }
          return 'N/A';
        },
      },
      state: {
        page: 1,
        perPage: 10,
        field: 'creationDate',
        ascending: false,
      },
    };
  },

  watch: {
    state: {
      handler() {
        this.daysOffFetch();
      },
      deep: true,
    },
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    },
    dayOffGridData() {
      return this.daysOffHistory.map((user) => {
        const res = {};
        this.daysOffFields.forEach((field) => {
          if (this.daysOffFieldsGridFill[field]) {
            res[field] = this.daysOffFieldsGridFill[field](user);
          }
        });
        return res;
      });
    },
  },

  methods: {
    showReason(reason) {
      this.selectedMotif = reason;
      this.$refs.reasonModal.openModal();
    },
    daysOffFetch() {
      this.loading = true;
      this.$services.absenceRequest
        .findAll(
          Object.assign({}, this.model, { type: 'SIMPLE_ABSENCE',userReference : this.user.reference }),
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields,
        )
        .then((res) => {
          this.loading = false;
          this.count = res.data.count;
          this.daysOffHistory = res.data.data;
        });
    },
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.daysOffFetch();
  },
};
</script>
